module.exports = __webpack_public_path__ + "img/phone_screen_01@2x.27460712.png";